<template>
    <div id="fixedBtn" class="clear bcw buybar">
      <div class="buybar__content clear">
        <van-button type="primary" size="large" class="fs3">提交申请</van-button>
      </div>
    </div>
</template>
<script>
import Func from "@/assets/scripts/func";
export default {
    name: 'TheBtnbar',
    data(){
        return{
            screenHeight: document.documentElement.clientHeight   // 这里是给到了一个默认值 （屏幕可见高度）
        }
    },
    mounted () {
        const that = this
        window.onresize = () => {
            return (() => {
                that.screenHeight = document.documentElement.clientHeight
            })()
        }
    },
    watch: {
        screenHeight (newV,oldV) {
            if(newV < oldV){
                // 变小
                document.getElementById('fixedBtn').style.position="static"
            }else{
                // 正常
                document.getElementById('fixedBtn').style.position="fixed"
            }
        }
    }
}


</script>
<style lang="less" scoped>
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheBtnBar.vue